import { useEffect } from "react";
function useKeyboardDetector(className) {
  useEffect(function () {
    var initialHeight = window.innerHeight;
    var isKeyboardOpen = false;
    var handleResize = function handleResize() {
      var newHeight = window.innerHeight;
      if (newHeight < initialHeight && !isKeyboardOpen) {
        document.body.classList.add(className);
        isKeyboardOpen = true;
      } else if (newHeight >= initialHeight && isKeyboardOpen) {
        document.body.classList.remove(className);
        isKeyboardOpen = false;
      }
    };
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [className]);
}
export default useKeyboardDetector;